import { IColumnPk } from '../../webapi';

export class TableConfigGroup {
    GroupName: string;
    GroupLst: IColumnPk[];

    constructor(GroupName: string, GroupLst: IColumnPk[]){
      this.GroupName = GroupName;
      this.GroupLst = GroupLst;
    }
}
